import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import SettingsIcon from '../../../../../assets/icons/settings.svg';
import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (
  _event: NotificationEvent,
  context: EventContextsMap,
): EventData => {
  const {user} = context;
  const email = user?.external_auth_status?.email ?? '';

  return {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: 'Your Coach',
    icon: SettingsIcon,
    iconGradient: 'danger',
    title: i18n.t('notifications:google_oauth_access_became_invalid.title', {
      email,
    }),
  };
};
